/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import { documentService } from "../views/service/document.service";
import { constants } from "@/shared/constants";
import Vue from "vue";
import { helpers } from "@/shared/helper";

const state = {
  documents: [],
  selectedDocuments: [],
  documentsTypes: [],
  step: 1,
  disabledStep1: true,
  draftDocuments: [],
  draftImportInMassDocuments: [],
  leavePage: false,
  draftDocumentsReplace: [],
  docFormInvalid: false,
  versionsDocument: []
};
const getters = {
  getDocuments: state => state.documents,
  getSelectedDocuments: state => state.selectedDocuments,
  getDocumentsTypes: state => state.documentsTypes,
  getCurrentStep: state => state.step,
  getStep1Status: state => state.disabledStep1,
  getDraftDocuments: state => state.draftDocuments,
  getDraftImportInMassDocuments: state => state.draftImportInMassDocuments,
  getDraftDocumentsReplace: state => state.draftDocumentsReplace,
  getLeavePage: state => state.leavePage,
  getDocFormInvalid: state => state.docFormInvalid,
  getVersionsDocument: state => state.versionsDocument
};
const actions = {
  getDocumentsAction({ commit }, { id, customFilter, search, myPager }) {
    documentService.fetchDocumets(id, customFilter, search, myPager).then(
      result => {
        commit("setDocuments", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  saveDocumentsAction(
    { commit, dispatch },
    { id, customFilter, documentsToUpload }
  ) {
    documentService.saveDocuments(documentsToUpload).then(() => {
      if (id && customFilter) {
        dispatch("getDocumentsAction", {
          id: id,
          customFilter: customFilter,
          search: ""
        });
      }
    });
  },
  deleteDraftDocumentsAction({ commit }, { documentsName, showLoader }) {
    documentService.deleteDraftDocuments(documentsName, showLoader).then(
      () => {},
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getDocumentsTypesAction({ commit }) {
    commit(
      "setDocumentsTypes",
      // helpers.isAnArtisan()
      //   ? constants.DOCUMENT_TYPES_ARTISAN
      //   : constants.DOCUMENT_TYPES
      constants.DOCUMENT_TYPES_NEW
    );
  },
  editDocumentTypesAction({ commit }, { documents }) {
    documentService.editDocumentType(documents).then(
      result => {
        commit("setNewTypes", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  deleteDocumentsAction({ commit }, { documentsIds }) {
    documentService.deleteDocuments(documentsIds).then(
      result => {
        commit("deleteDocuments", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  replaceDocumentsAction(
    { commit, dispatch },
    { replaceDocument, id, customFilter }
  ) {
    documentService.replaceDocument(replaceDocument).then(
      () => {
        Vue.prototype.$notification.success(
          "Le document a été remplacé avec succès."
        );
        if (id && customFilter) {
          dispatch("getDocumentsAction", {
            id: id,
            customFilter: customFilter,
            search: ""
          });
        }
      },
      error => {
        Vue.prototype.$notification.error(
          "Erreur lors de remplacement du document."
        );
        Vue.$log.error(error);
      }
    );
  },
  versionsDocumentsAction({ commit }, { docId }) {
    documentService.versionsDocument(docId).then(
      result => {
        commit("setVersionsDocument", result.slice().reverse());
      },
      error => {
        Vue.$log.error(error);
      }
    );
  }
};
const mutations = {
  setDocuments(state, val) {
    state.documents = val;
  },
  setSelectedDocuments(state, val) {
    state.selectedDocuments = val;
  },
  setDocumentsTypes(state, val) {
    state.documentsTypes = val;
  },
  setCurrentStep(state, val) {
    state.step = val;
  },
  setStep1Status(state, val) {
    state.disabledStep1 = val;
  },
  setNewTypes(state, val) {
    val.forEach(newDoc => {
      state.documents.forEach(oldDoc => {
        if (oldDoc.id === newDoc.id) {
          oldDoc.types = newDoc.types;
        }
      });
    });
  },
  deleteDocuments(state, val) {
    state.documents = state.documents.filter(
      document => !val.some(elm => elm.id === document.id)
    );
  },
  setDraftDocuments(state, val) {
    state.draftDocuments = val;
  },
  setDraftImportInMassDocuments(state, val) {
    val.forEach(newFile => {
      newFile.success = true;
      newFile.progress = 100;
    });
    state.draftImportInMassDocuments = val;
  },
  setDraftDocumentsReplace(state, val) {
    state.draftDocumentsReplace = val;
  },
  setLeavePage(state, val) {
    state.leavePage = val;
  },
  setDocFormInvalid(state, val) {
    state.docFormInvalid = val;
  },
  setVersionsDocument(state, val) {
    state.versionsDocument = val;
  }
};

export const document = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
